import React, { useState } from "react";
import { AccordionContainer } from "./Accordion.styled";
import { SegmentSubTitle } from "../SegmentSettings/SegmentSettings.styled";

const CustomAccordion = ({
  title,
  icon,
  children,
  padding,
  expanded = false,
  secondaryIcon = null,
}) => {
  const [isExpanded, setisExpanded] = useState(expanded);

  const handleToggle = () => {
    setisExpanded((prev) => !prev);
  };

  return (
    <AccordionContainer className={isExpanded ? "expanded" : ""}>
      <div className="accordion-summary" onClick={handleToggle}>
        <SegmentSubTitle>{title}</SegmentSubTitle>
        <div className="accordion-icon">
          {secondaryIcon && secondaryIcon}
          {icon}
        </div>
      </div>
      <div className="accordion-details" style={{ padding }}>
        {children}
      </div>
    </AccordionContainer>
  );
};

export default CustomAccordion;
